import { SoapUtils } from "../../../utils/SoapUtils";

export interface Invoice {
    accountBase?: string;
    accountBaseName?: string;
    accountRound?: string;
    accountRoundName?: string;
    accountTotal?: string;
    accountTotalName?: string;
    accountVAT?: string;
    accountVATName?: string;
    acl?: string;
    activity?: string;
    activityName?: string;
    activityRefId?: string;
    bankAccount?: string;
    bankCode?: string;
    bankIBAN?: string;
    constantSymbol?: string;
    created?: Date;
    createdBy?: string;
    createdByName?: string;
    currency?: string;
    currencyRate?: string;
    customer?: string;
    customerCity?: string;
    customerContact?: string;
    customerContactName?: string;
    customerCountry?: string;
    customerName?: string;
    customerRegId?: string;
    customerRegion?: string;
    customerStreet?: string;
    customerVATId?: string;
    customerZIP?: string;
    description?: string;
    dimension1?: string;
    dimension1Name?: string;
    dimension2?: string;
    dimension2Name?: string;
    dimension3?: string;
    dimension3Name?: string;
    dueDate?: Date;
    externalApprovalBy?: string;
    externalApprovalByName?: string;
    externalApprovalDate?: string;
    externalNumber?: string;
    externalReferenceNumber?: string;
    headerText?: string;
    footerText?: string;
    summaryText: string;
    invoicePrintTemplate?: string;
    timesheetPrintTemplate?: string;
    periodFrom?: Date;
    periodTo?: Date;
    folder?: string;
    folderName?: string;
    folderRefId?: string;
    hasChild?: string;
    id?: string;
    internalApprovalBy?: string;
    internalApprovalByName?: string;
    internalApprovalDate?: string;
    internalDescription?: string;
    invoiceNumber?: string;
    draftType?: string;
    isDraft?: string;
    isGrouped?: string;
    isHeader?: string;
    isIssued?: string;
    isOrder?: string;
    baseType?: string;
    issuedDate?: Date;
    journal?: string;
    journalName?: string;
    journalTreeHandle?: string;
    max_len?: number;
    modified?: Date;
    modifiedBy?: string;
    modifiedByName?: string;
    name?: string;
    nextNextState?: string;
    nextNextMinApprovals?: number;
    parent?: string;
    subject?: string;
    paymentMethod?: string;
    paymentMethodName?: string;
    priority?: number;
    project?: string;
    projectName?: string;
    projectRefId?: string;
    provider?: string;
    providerCity?: string;
    providerCountry?: string;
    providerName?: string;
    providerRegion?: string;
    providerStreet?: string;
    providerZIP?: string;
    recordId?: string;
    shipTo?: string;
    shipToCity?: string;
    shipToCountry?: string;
    shipToCustomer?: string;
    shipToName?: string;
    shipToRegion?: string;
    shipToStreet?: string;
    shipToZIP?: string;
    state?: string;
    stateName?: string;
    taxationDate?: Date;
    templateAcc?: string;
    toBePaid?: string;
    toBePaidDate: Date;
    total?: number;
    totalWithVAT?: number;
    transactionTreeHandle?: string;
    treeHandle?: string;
    userId?: string;
    userName?: string;
    confirmedState?: string;
    confirmedStateName?: string;
    needConfirmations?: string;
    confirmNote?: string;
    all?: string;
    forApproval?: string;
    thisMonth?: string;
    previousMonth?: string;
    overdue?: string;
    forApprovalState?: string;
    forApprovalByUser?: string;
    transactionsDimension1?: string;
    transactionsDimension2?: string;
    transactionsDimension3?: string;
    transactionsDimension1Name?: string;
    transactionsDimension2Name?: string;
    transactionsDimension3Name?: string;
    transactionsName?: string;
    transactionsDescription?: string;
    nextState?: string;
    minApprovals?: string;
    pin?: string;
    field0?: string;
    field0Id?: string;
    field0Txt?: string;
    field1?: string;
    field1Id?: string;
    field1Txt?: string;
    field2?: string;
    field2Id?: string;
    field2Txt?: string;
    field3?: string;
    field3Id?: string;
    field3Txt?: string;
    field4: string;
    field4Id: string;
    field4Txt?: string;
    field5?: string;
    field5Id?: string;
    field5Txt?: string;
    field6?: string;
    field6Id?: string;
    field6Txt?: string;
    field7?: string;
    field7Id?: string;
    field7Txt?: string;
    field8?: string;
    field8Id?: string;
    field8Txt?: string;
    field9?: string;
    field9Id?: string;
    field9Txt?: string;
    paymentReference?: string;
    dateTransaction?: Date;
    valueRestraint?: string;
    valueAuthorized?: string;
    bankBic?: string;
    bankNoteDomestic?: string;
    bankNoteForeign?: string;
    customId?: string;
    paidSync?: string;
    paidManual?: string;
    paymentStatus?: string;
    SETAPPROVALS?: IDS;
    CONFIRMATIONS?: Confirmations;
    TRANSACTION?: Transaction[];
    DOCUMENT?: Document[];
    STATES?: States;
    APPROVEDBY?: IDS;
    APPROVALS?: IDS;
    NEXTAPPROVALS?: IDS;
    POTENTIALAPPROVALS?: IDS;
    SUMSTATES?: IDS;
    RELATED_INVOICES?: RelatedInvoices;
}

export function toInvoiceXml(invoice?: Invoice): string {
    if (!invoice) return '';
    var xml = `<INVOICE>`;
    xml += SoapUtils.makeNode(invoice.accountBase, 'accountBase');
    xml += SoapUtils.makeNode(invoice.accountBaseName, 'accountBaseName');
    xml += SoapUtils.makeNode(invoice.accountRound, 'accountRound');
    xml += SoapUtils.makeNode(invoice.accountRoundName, 'accountRoundName');
    xml += SoapUtils.makeNode(invoice.accountTotal, 'accountTotal');
    xml += SoapUtils.makeNode(invoice.accountTotalName, 'accountTotalName');
    xml += SoapUtils.makeNode(invoice.accountVAT, 'accountVAT');
    xml += SoapUtils.makeNode(invoice.accountVATName, 'accountVATName');
    xml += SoapUtils.makeNode(invoice.acl, 'acl');
    xml += SoapUtils.makeNode(invoice.activity, 'activity');
    xml += SoapUtils.makeNode(invoice.activityName, 'activityName');
    xml += SoapUtils.makeNode(invoice.activityRefId, 'activityRefId');
    xml += SoapUtils.makeNode(invoice.bankAccount, 'bankAccount');
    xml += SoapUtils.makeNode(invoice.bankCode, 'bankCode');
    xml += SoapUtils.makeNode(invoice.bankIBAN, 'bankIBAN');
    xml += SoapUtils.makeNode(invoice.constantSymbol, 'constantSymbol');
    xml += SoapUtils.makeNode(invoice.created, 'created');
    xml += SoapUtils.makeNode(invoice.createdBy, 'createdBy');
    xml += SoapUtils.makeNode(invoice.createdByName, 'createdByName');
    xml += SoapUtils.makeNode(invoice.currency, 'currency');
    xml += SoapUtils.makeNode(invoice.currencyRate, 'currencyRate');
    xml += SoapUtils.makeNode(invoice.customer, 'customer');
    xml += SoapUtils.makeNode(invoice.customerCity, 'customerCity');
    xml += SoapUtils.makeNode(invoice.customerContact, 'customerContact');
    xml += SoapUtils.makeNode(invoice.customerContactName, 'customerContactName');
    xml += SoapUtils.makeNode(invoice.customerCountry, 'customerCountry');
    xml += SoapUtils.makeNode(invoice.customerName, 'customerName');
    xml += SoapUtils.makeNode(invoice.customerRegId, 'customerRegId');
    xml += SoapUtils.makeNode(invoice.customerRegion, 'customerRegion');
    xml += SoapUtils.makeNode(invoice.customerStreet, 'customerStreet');
    xml += SoapUtils.makeNode(invoice.customerVATId, 'customerVATId');
    xml += SoapUtils.makeNode(invoice.customerZIP, 'customerZIP');
    xml += SoapUtils.makeNode(invoice.description, 'description');
    xml += SoapUtils.makeNode(invoice.dimension1, 'dimension1');
    xml += SoapUtils.makeNode(invoice.dimension1Name, 'dimension1Name');
    xml += SoapUtils.makeNode(invoice.dimension2, 'dimension2');
    xml += SoapUtils.makeNode(invoice.dimension2Name, 'dimension2Name');
    xml += SoapUtils.makeNode(invoice.dimension3, 'dimension3');
    xml += SoapUtils.makeNode(invoice.dimension3Name, 'dimension3Name');
    xml += SoapUtils.makeNode(invoice.dueDate, 'dueDate');
    xml += SoapUtils.makeNode(invoice.externalApprovalBy, 'externalApprovalBy');
    xml += SoapUtils.makeNode(invoice.externalApprovalByName, 'externalApprovalByName');
    xml += SoapUtils.makeNode(invoice.externalApprovalDate, 'externalApprovalDate');
    xml += SoapUtils.makeNode(invoice.externalNumber, 'externalNumber');
    xml += SoapUtils.makeNode(invoice.externalReferenceNumber, 'externalReferenceNumber');
    xml += SoapUtils.makeNode(invoice.headerText, 'headerText');
    xml += SoapUtils.makeNode(invoice.footerText, 'footerText');
    xml += SoapUtils.makeNode(invoice.summaryText, 'summaryText');
    xml += SoapUtils.makeNode(invoice.invoicePrintTemplate, 'invoicePrintTemplate');
    xml += SoapUtils.makeNode(invoice.timesheetPrintTemplate, 'timesheetPrintTemplate');
    xml += SoapUtils.makeNode(invoice.periodFrom, 'periodFrom');
    xml += SoapUtils.makeNode(invoice.periodTo, 'periodTo');
    xml += SoapUtils.makeNode(invoice.folder, 'folder');
    xml += SoapUtils.makeNode(invoice.folderName, 'folderName');
    xml += SoapUtils.makeNode(invoice.folderRefId, 'folderRefId');
    xml += SoapUtils.makeNode(invoice.hasChild, 'hasChild');
    xml += SoapUtils.makeNode(invoice.id, 'id');
    xml += SoapUtils.makeNode(invoice.internalApprovalBy, 'internalApprovalBy');
    xml += SoapUtils.makeNode(invoice.internalApprovalByName, 'internalApprovalByName');
    xml += SoapUtils.makeNode(invoice.internalApprovalDate, 'internalApprovalDate');
    xml += SoapUtils.makeNode(invoice.internalDescription, 'internalDescription');
    xml += SoapUtils.makeNode(invoice.invoiceNumber, 'invoiceNumber');
    xml += SoapUtils.makeNode(invoice.draftType, 'draftType');
    xml += SoapUtils.makeNode(invoice.isDraft, 'isDraft');
    xml += SoapUtils.makeNode(invoice.isGrouped, 'isGrouped');
    xml += SoapUtils.makeNode(invoice.isHeader, 'isHeader');
    xml += SoapUtils.makeNode(invoice.isIssued, 'isIssued');
    xml += SoapUtils.makeNode(invoice.isOrder, 'isOrder');
    xml += SoapUtils.makeNode(invoice.baseType, 'baseType');
    xml += SoapUtils.makeNode(invoice.issuedDate, 'issuedDate');
    xml += SoapUtils.makeNode(invoice.journal, 'journal');
    xml += SoapUtils.makeNode(invoice.journalName, 'journalName');
    xml += SoapUtils.makeNode(invoice.journalTreeHandle, 'journalTreeHandle');
    xml += SoapUtils.makeNode(invoice.max_len, 'max_len');
    xml += SoapUtils.makeNode(invoice.modified, 'modified');
    xml += SoapUtils.makeNode(invoice.modifiedBy, 'modifiedBy');
    xml += SoapUtils.makeNode(invoice.modifiedByName, 'modifiedByName');
    xml += SoapUtils.makeNode(invoice.name, 'name');
    xml += SoapUtils.makeNode(invoice.nextNextState, 'nextNextState');
    xml += SoapUtils.makeNode(invoice.nextNextMinApprovals, 'nextNextMinApprovals');
    xml += SoapUtils.makeNode(invoice.parent, 'parent');
    xml += SoapUtils.makeNode(invoice.subject, 'subject');
    xml += SoapUtils.makeNode(invoice.paymentMethod, 'paymentMethod');
    xml += SoapUtils.makeNode(invoice.paymentMethodName, 'paymentMethodName');
    xml += SoapUtils.makeNode(invoice.priority, 'priority');
    xml += SoapUtils.makeNode(invoice.project, 'project');
    xml += SoapUtils.makeNode(invoice.projectName, 'projectName');
    xml += SoapUtils.makeNode(invoice.projectRefId, 'projectRefId');
    xml += SoapUtils.makeNode(invoice.provider, 'provider');
    xml += SoapUtils.makeNode(invoice.providerCity, 'providerCity');
    xml += SoapUtils.makeNode(invoice.providerCountry, 'providerCountry');
    xml += SoapUtils.makeNode(invoice.providerName, 'providerName');
    xml += SoapUtils.makeNode(invoice.providerRegion, 'providerRegion');
    xml += SoapUtils.makeNode(invoice.providerStreet, 'providerStreet');
    xml += SoapUtils.makeNode(invoice.providerZIP, 'providerZIP');
    xml += SoapUtils.makeNode(invoice.recordId, 'recordId');
    xml += SoapUtils.makeNode(invoice.shipTo, 'shipTo');
    xml += SoapUtils.makeNode(invoice.shipToCity, 'shipToCity');
    xml += SoapUtils.makeNode(invoice.shipToCountry, 'shipToCountry');
    xml += SoapUtils.makeNode(invoice.shipToCustomer, 'shipToCustomer');
    xml += SoapUtils.makeNode(invoice.shipToName, 'shipToName');
    xml += SoapUtils.makeNode(invoice.shipToRegion, 'shipToRegion');
    xml += SoapUtils.makeNode(invoice.shipToStreet, 'shipToStreet');
    xml += SoapUtils.makeNode(invoice.shipToZIP, 'shipToZIP');
    xml += SoapUtils.makeNode(invoice.state, 'state');
    xml += SoapUtils.makeNode(invoice.stateName, 'stateName');
    xml += SoapUtils.makeNode(invoice.taxationDate, 'taxationDate');
    xml += SoapUtils.makeNode(invoice.templateAcc, 'templateAcc');
    xml += SoapUtils.makeNode(invoice.toBePaid, 'toBePaid');
    xml += SoapUtils.makeNode(invoice.toBePaidDate, 'toBePaidDate');
    xml += SoapUtils.makeNode(invoice.total, 'total');
    xml += SoapUtils.makeNode(invoice.totalWithVAT, 'totalWithVAT');
    xml += SoapUtils.makeNode(invoice.transactionTreeHandle, 'transactionTreeHandle');
    xml += SoapUtils.makeNode(invoice.treeHandle, 'treeHandle');
    xml += SoapUtils.makeNode(invoice.userId, 'userId');
    xml += SoapUtils.makeNode(invoice.userName, 'userName');
    xml += SoapUtils.makeNode(invoice.confirmedState, 'confirmedState');
    xml += SoapUtils.makeNode(invoice.confirmedStateName, 'confirmedStateName');
    xml += SoapUtils.makeNode(invoice.needConfirmations, 'needConfirmations');
    xml += SoapUtils.makeNode(invoice.confirmNote, 'confirmNote');
    xml += SoapUtils.makeNode(invoice.transactionsDimension1, 'transactionsDimension1');
    xml += SoapUtils.makeNode(invoice.transactionsDimension2, 'transactionsDimension2');
    xml += SoapUtils.makeNode(invoice.transactionsDimension3, 'transactionsDimension3');
    xml += SoapUtils.makeNode(invoice.transactionsDimension1Name, 'transactionsDimension1Name');
    xml += SoapUtils.makeNode(invoice.transactionsDimension2Name, 'transactionsDimension2Name');
    xml += SoapUtils.makeNode(invoice.transactionsDimension3Name, 'transactionsDimension3Name');
    xml += SoapUtils.makeNode(invoice.transactionsName, 'transactionsName');
    xml += SoapUtils.makeNode(invoice.transactionsDescription, 'transactionsDescription');
    xml += SoapUtils.makeNode(invoice.nextState, 'nextState');
    xml += SoapUtils.makeNode(invoice.minApprovals, 'minApprovals');
    xml += SoapUtils.makeNode(invoice.pin, 'pin');
    xml += SoapUtils.makeNode(invoice.field0, 'field0');
    xml += SoapUtils.makeNode(invoice.field0Id, 'field0Id');
    xml += SoapUtils.makeNode(invoice.field0Txt, 'field0Txt');
    xml += SoapUtils.makeNode(invoice.field1, 'field1');
    xml += SoapUtils.makeNode(invoice.field1Id, 'field1Id');
    xml += SoapUtils.makeNode(invoice.field1Txt, 'field1Txt');
    xml += SoapUtils.makeNode(invoice.field2, 'field2');
    xml += SoapUtils.makeNode(invoice.field2Id, 'field2Id');
    xml += SoapUtils.makeNode(invoice.field2Txt, 'field2Txt');
    xml += SoapUtils.makeNode(invoice.field3, 'field3');
    xml += SoapUtils.makeNode(invoice.field3Id, 'field3Id');
    xml += SoapUtils.makeNode(invoice.field3Txt, 'field3Txt');
    xml += SoapUtils.makeNode(invoice.field4, 'field4');
    xml += SoapUtils.makeNode(invoice.field4Id, 'field4Id');
    xml += SoapUtils.makeNode(invoice.field4Txt, 'field4Txt');
    xml += SoapUtils.makeNode(invoice.field5, 'field5');
    xml += SoapUtils.makeNode(invoice.field5Id, 'field5Id');
    xml += SoapUtils.makeNode(invoice.field5Txt, 'field5Txt');
    xml += SoapUtils.makeNode(invoice.field6, 'field6');
    xml += SoapUtils.makeNode(invoice.field6Id, 'field6Id');
    xml += SoapUtils.makeNode(invoice.field6Txt, 'field6Txt');
    xml += SoapUtils.makeNode(invoice.field7, 'field7');
    xml += SoapUtils.makeNode(invoice.field7Id, 'field7Id');
    xml += SoapUtils.makeNode(invoice.field7Txt, 'field7Txt');
    xml += SoapUtils.makeNode(invoice.field8, 'field8');
    xml += SoapUtils.makeNode(invoice.field8Id, 'field8Id');
    xml += SoapUtils.makeNode(invoice.field8Txt, 'field8Txt');
    xml += SoapUtils.makeNode(invoice.field9, 'field9');
    xml += SoapUtils.makeNode(invoice.field9Id, 'field9Id');
    xml += SoapUtils.makeNode(invoice.field9Txt, 'field9Txt');
    xml += SoapUtils.makeNode(invoice.paymentReference, 'paymentReference');
    xml += SoapUtils.makeNode(invoice.dateTransaction, 'dateTransaction');
    xml += SoapUtils.makeNode(invoice.valueRestraint, 'valueRestraint');
    xml += SoapUtils.makeNode(invoice.valueAuthorized, 'valueAuthorized');
    xml += SoapUtils.makeNode(invoice.bankBic, 'bankBic');
    xml += SoapUtils.makeNode(invoice.bankNoteDomestic, 'bankNoteDomestic');
    xml += SoapUtils.makeNode(invoice.bankNoteForeign, 'bankNoteForeign');
    xml += SoapUtils.makeNode(invoice.customId, 'customId');
    xml += SoapUtils.makeNode(invoice.paidSync, 'paidSync');
    xml += SoapUtils.makeNode(invoice.paidManual, 'paidManual');
    xml += SoapUtils.makeNode(invoice.paymentStatus, 'paymentStatus');
    xml += toIDSXml(invoice.SETAPPROVALS, 'SETAPPROVALS');
    xml += toConfirmationsXml(invoice.CONFIRMATIONS);
    xml += SoapUtils.makeNodeArray(invoice.TRANSACTION, toTransactionXml);
    xml += SoapUtils.makeNodeArray(invoice.DOCUMENT, toDocumentXml);
    xml += toStatesXml(invoice.STATES);
    xml += toIDSXml(invoice.APPROVEDBY, 'APPROVEDBY');
    xml += toIDSXml(invoice.APPROVALS, 'APPROVALS');
    xml += toIDSXml(invoice.NEXTAPPROVALS, 'NEXTAPPROVALS');
    xml += toIDSXml(invoice.POTENTIALAPPROVALS, 'POTENTIALAPPROVALS');
    xml += toIDSXml(invoice.SUMSTATES, 'SUMSTATES');
    xml += toRelatedInvoicesXml(invoice.RELATED_INVOICES);
    xml += `</INVOICE>`;
    return xml;
}

export interface Confirmations {
    USER?: User[];
}

export function toConfirmationsXml(confirmations?: Confirmations): string {
    if (!confirmations) return '';
    return SoapUtils.makeNodeArray(confirmations.USER, toUserXml, 'CONFIRMATIONS');
}

export interface User {
    id?:    string;
    name?:  string;
    isset?: string;
    note?:  string;
}

export function toUserXml(user?: User): string {
    if (!user) return '';
    var xml = `<USER>`;
    xml += SoapUtils.makeNode(user.id, 'id');
    xml += SoapUtils.makeNode(user.name, 'name');
    xml += SoapUtils.makeNode(user.isset, 'isset');
    xml += SoapUtils.makeNode(user.note, 'note');
    xml += `</USER>`;
    return xml;
}
export interface Document {
    documentId?: string;
    name?:       string;
}

export function toDocumentXml(document?: Document): string {
    if (!document) return '';
    var xml = `<DOCUMENT>`;
    xml += SoapUtils.makeNode(document.documentId, 'documentId');
    xml += SoapUtils.makeNode(document.name, 'name');
    xml += `</DOCUMENT>`;
    return xml;
}

export interface Transaction {
    id?:                        string;
    treeHandle?:                string;
    created?:                   string;
    createdBy?:                 string;
    createdByName?:             string;
    modified?:                  string;
    modifiedBy?:                string;
    modifiedByName?:            string;
    acl?:                       string;
    templateAcc?:               string;
    account?:                   string;
    accountName?:               string;
    activity?:                  string;
    attrib0?:                   string;
    attrib0_id?:                string;
    attrib1?:                   string;
    attrib1_id?:                string;
    attrib2?:                   string;
    attrib2_id?:                string;
    attrib3?:                   string;
    attrib3_id?:                string;
    attrib4?:                   string;
    attrib4_id?:                string;
    attrib5?:                   string;
    attrib5_id?:                string;
    attrib6?:                   string;
    attrib6_id?:                string;
    attrib7?:                   string;
    attrib7_id?:                string;
    attrib8?:                   string;
    attrib8_id?:                string;
    attrib9?:                   string;
    attrib9_id?:                string;
    bookkeepingAmount?:         string;
    bookkeepingAmountReverted?: string;
    bookkeepingCurrency?:       string;
    bookkeepingCurrencyRate?:   string;
    bookkeepingUnitPrice?:      string;
    catalogPrice?:              string;
    customId?:                  string;
    description?:               string;
    dimension1?:                string;
    dimension1Name?:            string;
    dimension2?:                string;
    dimension2Name?:            string;
    dimension3?:                string;
    dimension3Name?:            string;
    direction?:                 string;
    entry?:                     string;
    folder?:                    string;
    folderName?:                string;
    childKey?:                  string;
    invoicedCat?:               string;
    invoicedQty?:               string;
    item?:                      string;
    itemComponentCategory?:     string;
    itemComponentCategoryName?: string;
    itemDescription?:           string;
    itemName?:                  string;
    itemQuantity?:              string;
    itemRefId?:                 string;
    itemSerial?:                string;
    journal?:                   string;
    journalName?:               string;
    listId?:                    string;
    max_len?:                   string;
    name?:                      string;
    orderIndex?:                string;
    ordertrn?:                  string;
    otherAmount?:               string;
    otherCurrency?:             string;
    otherCurrencyRate?:         string;
    otherUnitPrice?:            string;
    pairingKey?:                string;
    pairingSum?:                string;
    parent?:                    string;
    subject?:                   string;
    parentId?:                  string;
    parentKey?:                 string;
    priority?:                  string;
    project?:                   string;
    projectName?:               string;
    recordId?:                  string;
    remove?:                    string;
    splitSwitch?:               string;
    transactionDate?:           string;
    type?:                      string;
    userId?:                    string;
    userName?:                  string;
    VAT?:                       string;
    VATTitle?:                  string;
    VATValue?:                  number;
    voucher?:                   string;
    SHARES?:                    Shares;
}

export function toTransactionXml(transaction?: Transaction): string {
    if (!transaction) return '';
    var xml = `<TRANSACTION>`;
    xml += SoapUtils.makeNode(transaction.id, 'id');
    xml += SoapUtils.makeNode(transaction.treeHandle, 'treeHandle');
    xml += SoapUtils.makeNode(transaction.created, 'created');
    xml += SoapUtils.makeNode(transaction.createdBy, 'createdBy');
    xml += SoapUtils.makeNode(transaction.createdByName, 'createdByName');
    xml += SoapUtils.makeNode(transaction.modified, 'modified');
    xml += SoapUtils.makeNode(transaction.modifiedBy, 'modifiedBy');
    xml += SoapUtils.makeNode(transaction.modifiedByName, 'modifiedByName');
    xml += SoapUtils.makeNode(transaction.acl, 'acl');
    xml += SoapUtils.makeNode(transaction.templateAcc, 'templateAcc');
    xml += SoapUtils.makeNode(transaction.account, 'account');
    xml += SoapUtils.makeNode(transaction.accountName, 'accountName');
    xml += SoapUtils.makeNode(transaction.activity, 'activity');
    xml += SoapUtils.makeNode(transaction.attrib0, 'attrib0');
    xml += SoapUtils.makeNode(transaction.attrib0_id, 'attrib0_id');
    xml += SoapUtils.makeNode(transaction.attrib1, 'attrib1');
    xml += SoapUtils.makeNode(transaction.attrib1_id, 'attrib1_id');
    xml += SoapUtils.makeNode(transaction.attrib2, 'attrib2');
    xml += SoapUtils.makeNode(transaction.attrib2_id, 'attrib2_id');
    xml += SoapUtils.makeNode(transaction.attrib3, 'attrib3');
    xml += SoapUtils.makeNode(transaction.attrib3_id, 'attrib3_id');
    xml += SoapUtils.makeNode(transaction.attrib4, 'attrib4');
    xml += SoapUtils.makeNode(transaction.attrib4_id, 'attrib4_id');
    xml += SoapUtils.makeNode(transaction.attrib5, 'attrib5');
    xml += SoapUtils.makeNode(transaction.attrib5_id, 'attrib5_id');
    xml += SoapUtils.makeNode(transaction.attrib6, 'attrib6');
    xml += SoapUtils.makeNode(transaction.attrib6_id, 'attrib6_id');
    xml += SoapUtils.makeNode(transaction.attrib7, 'attrib7');
    xml += SoapUtils.makeNode(transaction.attrib7_id, 'attrib7_id');
    xml += SoapUtils.makeNode(transaction.attrib8, 'attrib8');
    xml += SoapUtils.makeNode(transaction.attrib8_id, 'attrib8_id');
    xml += SoapUtils.makeNode(transaction.attrib9, 'attrib9');
    xml += SoapUtils.makeNode(transaction.attrib9_id, 'attrib9_id');
    xml += SoapUtils.makeNode(transaction.bookkeepingAmount, 'bookkeepingAmount');
    xml += SoapUtils.makeNode(transaction.bookkeepingAmountReverted, 'bookkeepingAmountReverted');
    xml += SoapUtils.makeNode(transaction.bookkeepingCurrency, 'bookkeepingCurrency');
    xml += SoapUtils.makeNode(transaction.bookkeepingCurrencyRate, 'bookkeepingCurrencyRate');
    xml += SoapUtils.makeNode(transaction.bookkeepingUnitPrice, 'bookkeepingUnitPrice');
    xml += SoapUtils.makeNode(transaction.catalogPrice, 'catalogPrice');
    xml += SoapUtils.makeNode(transaction.customId, 'customId');
    xml += SoapUtils.makeNode(transaction.description, 'description');
    xml += SoapUtils.makeNode(transaction.dimension1, 'dimension1');
    xml += SoapUtils.makeNode(transaction.dimension1Name, 'dimension1Name');
    xml += SoapUtils.makeNode(transaction.dimension2, 'dimension2');
    xml += SoapUtils.makeNode(transaction.dimension2Name, 'dimension2Name');
    xml += SoapUtils.makeNode(transaction.dimension3, 'dimension3');
    xml += SoapUtils.makeNode(transaction.dimension3Name, 'dimension3Name');
    xml += SoapUtils.makeNode(transaction.direction, 'direction');
    xml += SoapUtils.makeNode(transaction.entry, 'entry');
    xml += SoapUtils.makeNode(transaction.folder, 'folder');
    xml += SoapUtils.makeNode(transaction.folderName, 'folderName');
    xml += SoapUtils.makeNode(transaction.childKey, 'childKey');
    xml += SoapUtils.makeNode(transaction.invoicedCat, 'invoicedCat');
    xml += SoapUtils.makeNode(transaction.invoicedQty, 'invoicedQty');
    xml += SoapUtils.makeNode(transaction.item, 'item');
    xml += SoapUtils.makeNode(transaction.itemComponentCategory, 'itemComponentCategory');
    xml += SoapUtils.makeNode(transaction.itemComponentCategoryName, 'itemComponentCategoryName');
    xml += SoapUtils.makeNode(transaction.itemDescription, 'itemDescription');
    xml += SoapUtils.makeNode(transaction.itemName, 'itemName');
    xml += SoapUtils.makeNode(transaction.itemQuantity, 'itemQuantity');
    xml += SoapUtils.makeNode(transaction.itemRefId, 'itemRefId');
    xml += SoapUtils.makeNode(transaction.itemSerial, 'itemSerial');
    xml += SoapUtils.makeNode(transaction.journal, 'journal');
    xml += SoapUtils.makeNode(transaction.journalName, 'journalName');
    xml += SoapUtils.makeNode(transaction.listId, 'listId');
    xml += SoapUtils.makeNode(transaction.max_len, 'max_len');
    xml += SoapUtils.makeNode(transaction.name, 'name');
    xml += SoapUtils.makeNode(transaction.orderIndex, 'orderIndex');
    xml += SoapUtils.makeNode(transaction.ordertrn, 'ordertrn');
    xml += SoapUtils.makeNode(transaction.otherAmount, 'otherAmount');
    xml += SoapUtils.makeNode(transaction.otherCurrency, 'otherCurrency');
    xml += SoapUtils.makeNode(transaction.otherCurrencyRate, 'otherCurrencyRate');
    xml += SoapUtils.makeNode(transaction.otherUnitPrice, 'otherUnitPrice');
    xml += SoapUtils.makeNode(transaction.pairingKey, 'pairingKey');
    xml += SoapUtils.makeNode(transaction.pairingSum, 'pairingSum');
    xml += SoapUtils.makeNode(transaction.parent, 'parent');
    xml += SoapUtils.makeNode(transaction.subject, 'subject');
    xml += SoapUtils.makeNode(transaction.parentId, 'parentId');
    xml += SoapUtils.makeNode(transaction.parentKey, 'parentKey');
    xml += SoapUtils.makeNode(transaction.priority, 'priority');
    xml += SoapUtils.makeNode(transaction.project, 'project');
    xml += SoapUtils.makeNode(transaction.projectName, 'projectName');
    xml += SoapUtils.makeNode(transaction.recordId, 'recordId');
    xml += SoapUtils.makeNode(transaction.remove, 'remove');
    xml += SoapUtils.makeNode(transaction.splitSwitch, 'splitSwitch');
    xml += SoapUtils.makeNode(transaction.transactionDate, 'transactionDate');
    xml += SoapUtils.makeNode(transaction.type, 'type');
    xml += SoapUtils.makeNode(transaction.userId, 'userId');
    xml += SoapUtils.makeNode(transaction.userName, 'userName');
    xml += SoapUtils.makeNode(transaction.VAT, 'VAT');
    xml += SoapUtils.makeNode(transaction.VATTitle, 'VATTitle');
    xml += SoapUtils.makeNode(transaction.VATValue, 'VATValue');
    xml += SoapUtils.makeNode(transaction.voucher, 'voucher');
    xml += toSharesXml(transaction.SHARES);
    xml += `</TRANSACTION>`;
    return xml;
}
export interface Shares {
    SHARE?: Share[];
}

export function toSharesXml(shares?: Shares): string {
    if (!shares) return '';
    return SoapUtils.makeNodeArray(shares.SHARE, toShareXml, 'SHARES');
}

export interface Share {
    GLItem?:             string;
    GLItemName?:        string;
    id?:                string;
    max_len?:           string;
    name?:              string;
    priority?:          string;
    recordId?:          string;
    remove?:            string;
    share?:             string;
    templateAcc?:       string;
    treeHandle?:        string;
    userId?:            string;
    userName?:          string;
    folder?:            string;
    project?:           string;
    activity?:          string;
    subject?:           string;
    isRemaining?:       string;
    units?:             string;
    shareUnits?:        string;
    percentage?:        string;
    total?:             string;
    bookKeepingAmount?: string;
    dimension1?:        string;
    dimension2?:        string;
    dimension3?:        string;
    dimension1Name?:    string;
    dimension2Name?:    string;
    dimension3Name?:    string;
    salesItem?:         string;
}

export function toShareXml(share: Share): string {
    if (!share) return '';
    var xml = `<SHARE>`;
    xml += SoapUtils.makeNode(share.GLItem, 'GLItem');
    xml += SoapUtils.makeNode(share.GLItemName, 'GLItemName');
    xml += SoapUtils.makeNode(share.id, 'id');
    xml += SoapUtils.makeNode(share.max_len, 'max_len');
    xml += SoapUtils.makeNode(share.name, 'name');
    xml += SoapUtils.makeNode(share.priority, 'priority');
    xml += SoapUtils.makeNode(share.recordId, 'recordId');
    xml += SoapUtils.makeNode(share.remove, 'remove');
    xml += SoapUtils.makeNode(share.share, 'share');
    xml += SoapUtils.makeNode(share.templateAcc, 'templateAcc');
    xml += SoapUtils.makeNode(share.treeHandle, 'treeHandle');
    xml += SoapUtils.makeNode(share.userId, 'userId');
    xml += SoapUtils.makeNode(share.userName, 'userName');
    xml += SoapUtils.makeNode(share.folder, 'folder');
    xml += SoapUtils.makeNode(share.project, 'project');
    xml += SoapUtils.makeNode(share.activity, 'activity');
    xml += SoapUtils.makeNode(share.subject, 'subject');
    xml += SoapUtils.makeNode(share.isRemaining, 'isRemaining');
    xml += SoapUtils.makeNode(share.units, 'units');
    xml += SoapUtils.makeNode(share.shareUnits, 'shareUnits');
    xml += SoapUtils.makeNode(share.percentage, 'percentage');
    xml += SoapUtils.makeNode(share.total, 'total');
    xml += SoapUtils.makeNode(share.bookKeepingAmount, 'bookKeepingAmount');
    xml += SoapUtils.makeNode(share.dimension1, 'dimension1');
    xml += SoapUtils.makeNode(share.dimension2, 'dimension2');
    xml += SoapUtils.makeNode(share.dimension3, 'dimension3');
    xml += SoapUtils.makeNode(share.dimension1Name, 'dimension1Name');
    xml += SoapUtils.makeNode(share.dimension2Name, 'dimension2Name');
    xml += SoapUtils.makeNode(share.dimension3Name, 'dimension3Name');
    xml += SoapUtils.makeNode(share.salesItem, 'salesItem');
    xml += `</SHARE>`;
    return xml;
}
export interface RelatedInvoices {
    INVOICE?: RelatedInvoice[];
}

export function toRelatedInvoicesXml(relatedInvoices?: RelatedInvoices): string {
    if (!relatedInvoices) return '';
    return SoapUtils.makeNodeArray(relatedInvoices.INVOICE, toRelatedInvoiceXml, 'RELATED_INVOICES');
}

export interface RelatedInvoice {
    invoiceNumber?: string;
    id?:            string;
}

export function toRelatedInvoiceXml(relatedInvoice: RelatedInvoice): string {
    var xml = `<INVOICE>`;
    xml += SoapUtils.makeNode(relatedInvoice.invoiceNumber, 'invoiceNumber');
    xml += SoapUtils.makeNode(relatedInvoice.id, 'id');
    xml += `</INVOICE>`;
    return xml;
}

export interface States {
    STATUS?: Status[];
}

export function toStatesXml(states?: States): string {    
    if (!states) return '';
    return SoapUtils.makeNodeArray(states.STATUS, toStatusXml, 'STATES');
}

export interface Status {
    priority?: string;
    state?:    string;
    pinCheck?: string;
}

export function toStatusXml(status: Status): string {
    var xml = `<STATUS>`;
    xml += SoapUtils.makeNode(status.priority, 'priority');
    xml += SoapUtils.makeNode(status.state, 'state');
    xml += SoapUtils.makeNode(status.pinCheck, 'pinCheck');
    xml += `</STATUS>`;
    return xml;
}
export interface FilterInvoice {
    approveBy?: string;
    baseType?: string;
    constantSymbol?: string;
    currency?: string;
    currencyRate?: string;
    customer?: string;
    customerName?: string;
    description?: string;
    dueDate?: string;
    activity?: string;
    project?: string;
    folder?: string;
    folderName?: string;
    invoiceNumber?: string;
    isIssued?: string;
    draftType?: string;
    isDraft?: string;
    issuedDate?: string;
    journal?: string;
    overdue?: string;
    paymentMethod?: string;
    provider?: string;
    providerName?: string;
    shipToCity?: string;
    shipToName?: string;
    state?: string;
    baseState?: string;
    taxationDate?: string;
    toApprove?: string;
    toBePaid?: string;
    total?: string;
    totalWithVAT?: string;
    product?: string;
    projectType?: string;
    activityType?: string;
    dimension1?: string;
    dimension2?: string;
    dimension3?: string;
    forApprovalByUser?: string;
    externalNumber?: string;
    externalReferenceNumber?: string;
    transactionsDimension1?: string;
    transactionsDimension2?: string;
    transactionsDimension3?: string;
    paymentReference?: string;
    customId?: string;
    paymentStatus?: string;
    field0?: string;
    field0Id?: string;
    field0Txt?: string;
    field1?: string;
    field1Id?: string;
    field1Txt?: string;
    field2?: string;
    field2Id?: string;
    field2Txt?: string;
    field3?: string;
    field3Id?: string;
    field3Txt?: string;
    field4?: string;
    field4Id?: string;
    field4Txt?: string;
    field5?: string;
    field5Id?: string;
    field5Txt?: string;
    field6?: string;
    field6Id?: string;
    field6Txt?: string;
    field7?: string;
    field7Id?: string;
    field7Txt?: string;
    field8?: string;
    field8Id?: string;
    field8Txt?: string;
    field9?: string;
    field9Id?: string;
    field9Txt?: string;
    STATES?: IDS;
    IDS?: IDS;
}

export interface IDS {
    ID?: string[];
}

export function toIDSXml(ids?: IDS, nodeName?: string): string {
    if (!ids) return '';
    const raw: any = (ids as any)?.ID ?? ids;
    const list = Array.isArray(raw) ? raw : [raw];
    const normalized = list.filter((id: any) => id !== undefined && id !== null && id !== '');
    return SoapUtils.makeNodeArray(normalized, id => SoapUtils.makeNode(id, 'ID'), nodeName || 'IDS');
}

export function toFilterInvoiceXml(filter?: FilterInvoice): string {
    if (!filter) return '';
    var xml = `<FILTER>`;
    xml += SoapUtils.makeNode(filter.approveBy, 'approveBy');
    xml += SoapUtils.makeNode(filter.baseType, 'baseType');
    xml += SoapUtils.makeNode(filter.constantSymbol, 'constantSymbol');
    xml += SoapUtils.makeNode(filter.currency, 'currency');
    xml += SoapUtils.makeNode(filter.currencyRate, 'currencyRate');
    xml += SoapUtils.makeNode(filter.customer, 'customer');
    xml += SoapUtils.makeNode(filter.customerName, 'customerName');
    xml += SoapUtils.makeNode(filter.description, 'description');
    xml += SoapUtils.makeNode(filter.dueDate, 'dueDate');
    xml += SoapUtils.makeNode(filter.activity, 'activity');
    xml += SoapUtils.makeNode(filter.project, 'project');
    xml += SoapUtils.makeNode(filter.folder, 'folder');
    xml += SoapUtils.makeNode(filter.folderName, 'folderName');
    xml += SoapUtils.makeNode(filter.invoiceNumber, 'invoiceNumber');
    xml += SoapUtils.makeNode(filter.isIssued, 'isIssued');
    xml += SoapUtils.makeNode(filter.draftType, 'draftType');
    xml += SoapUtils.makeNode(filter.isDraft, 'isDraft');
    xml += SoapUtils.makeNode(filter.issuedDate, 'issuedDate');
    xml += SoapUtils.makeNode(filter.journal, 'journal');
    xml += SoapUtils.makeNode(filter.overdue, 'overdue');
    xml += SoapUtils.makeNode(filter.paymentMethod, 'paymentMethod');
    xml += SoapUtils.makeNode(filter.provider, 'provider');
    xml += SoapUtils.makeNode(filter.providerName, 'providerName');
    xml += SoapUtils.makeNode(filter.shipToCity, 'shipToCity');
    xml += SoapUtils.makeNode(filter.shipToName, 'shipToName');
    xml += SoapUtils.makeNode(filter.state, 'state');
    xml += SoapUtils.makeNode(filter.baseState, 'baseState');
    xml += SoapUtils.makeNode(filter.taxationDate, 'taxationDate');
    xml += SoapUtils.makeNode(filter.toApprove, 'toApprove');
    xml += SoapUtils.makeNode(filter.toBePaid, 'toBePaid');
    xml += SoapUtils.makeNode(filter.total, 'total');
    xml += SoapUtils.makeNode(filter.totalWithVAT, 'totalWithVAT');
    xml += SoapUtils.makeNode(filter.product, 'product');
    xml += SoapUtils.makeNode(filter.projectType, 'projectType');
    xml += SoapUtils.makeNode(filter.activityType, 'activityType');
    xml += SoapUtils.makeNode(filter.dimension1, 'dimension1');
    xml += SoapUtils.makeNode(filter.dimension2, 'dimension2');
    xml += SoapUtils.makeNode(filter.dimension3, 'dimension3');
    xml += SoapUtils.makeNode(filter.forApprovalByUser, 'forApprovalByUser');
    xml += SoapUtils.makeNode(filter.externalNumber, 'externalNumber');
    xml += SoapUtils.makeNode(filter.externalReferenceNumber, 'externalReferenceNumber');
    xml += SoapUtils.makeNode(filter.transactionsDimension1, 'transactionsDimension1');
    xml += SoapUtils.makeNode(filter.transactionsDimension2, 'transactionsDimension2');
    xml += SoapUtils.makeNode(filter.transactionsDimension3, 'transactionsDimension3');
    xml += SoapUtils.makeNode(filter.paymentReference, 'paymentReference');
    xml += SoapUtils.makeNode(filter.customId, 'customId');
    xml += SoapUtils.makeNode(filter.paymentStatus, 'paymentStatus');
    xml += SoapUtils.makeNode(filter.field0, 'field0');
    xml += SoapUtils.makeNode(filter.field0Id, 'field0Id');
    xml += SoapUtils.makeNode(filter.field0Txt, 'field0Txt');
    xml += SoapUtils.makeNode(filter.field1, 'field1');
    xml += SoapUtils.makeNode(filter.field1Id, 'field1Id');
    xml += SoapUtils.makeNode(filter.field1Txt, 'field1Txt');
    xml += SoapUtils.makeNode(filter.field2, 'field2');
    xml += SoapUtils.makeNode(filter.field2Id, 'field2Id');
    xml += SoapUtils.makeNode(filter.field2Txt, 'field2Txt');
    xml += SoapUtils.makeNode(filter.field3, 'field3');
    xml += SoapUtils.makeNode(filter.field3Id, 'field3Id');
    xml += SoapUtils.makeNode(filter.field3Txt, 'field3Txt');
    xml += SoapUtils.makeNode(filter.field4, 'field4');
    xml += SoapUtils.makeNode(filter.field4Id, 'field4Id');
    xml += SoapUtils.makeNode(filter.field4Txt, 'field4Txt');
    xml += SoapUtils.makeNode(filter.field5, 'field5');
    xml += SoapUtils.makeNode(filter.field5Id, 'field5Id');
    xml += SoapUtils.makeNode(filter.field5Txt, 'field5Txt');
    xml += SoapUtils.makeNode(filter.field6, 'field6');
    xml += SoapUtils.makeNode(filter.field6Id, 'field6Id');
    xml += SoapUtils.makeNode(filter.field6Txt, 'field6Txt');
    xml += SoapUtils.makeNode(filter.field7, 'field7');
    xml += SoapUtils.makeNode(filter.field7Id, 'field7Id');
    xml += SoapUtils.makeNode(filter.field7Txt, 'field7Txt');
    xml += SoapUtils.makeNode(filter.field8, 'field8');
    xml += SoapUtils.makeNode(filter.field8Id, 'field8Id');
    xml += SoapUtils.makeNode(filter.field8Txt, 'field8Txt');
    xml += SoapUtils.makeNode(filter.field9, 'field9');
    xml += SoapUtils.makeNode(filter.field9Id, 'field9Id');
    xml += SoapUtils.makeNode(filter.field9Txt, 'field9Txt');
    xml += SoapUtils.makeNodeArray(filter.STATES?.ID, id => SoapUtils.makeNode(id, 'ID'), 'STATES');
    xml += SoapUtils.makeNodeArray(filter.IDS?.ID, id => SoapUtils.makeNode(id, 'ID'), 'IDS');
    xml += `</FILTER>`;
    return xml;
}
